<template>
  <div class="standardList">
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <div class="container">
      <div style="background: #fff;">
        <div class="nav">
          <div style="display: flex;align-items: center">
            <span style="color: #808080">当前位置：</span>
            <el-breadcrumb separator="/" style="font-size: 15px">
              <el-breadcrumb-item :to="{ path: '/knowledgeBase' }">
                <span>水泵知识库</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <span>标准列表</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 搜索框 -->
          <div class="serviceSearch">
            <div class="greatField-con-search">
              <el-input
                placeholder="请输入关键字"
                v-model="keyValue"
                @keyup.native.enter="query()"
                clearable
                ref="search"
              >
                <template slot="append">
                  <div class="greatField-con-search-icon" @click="query()"></div>
                </template>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 标准分类 -->
      <div class="type-box">
        <div class="type-name">标准分类：</div>
        <div class="type-list">
          <div
            class="type-item"
            v-for="(item,index) in typeList"
            :key="index"
            :class="curIndex == index? 'item-cur' : ''"
            @click="clickType(index,item.uuid)"
          >{{ item.title }}</div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="tablelist">
      <div class="book-con">
        <div class="noData" v-if="bookList.length == 0">暂无数据</div>
        <div
          class="book-item"
          v-for="(item,index) in bookList"
          :key="index"
          @click="handlePreview(item)"
        >
          <div class="book-img" :style="{ backgroundImage: `url(${bookImg})` }"></div>
          <div class="book-name">{{item.title}}</div>
        </div>
      </div>
    </div>
    <div v-if="bookList.length > 0" style="text-align: center;padding: 30px 0;">
      <el-pagination
        @current-change="onChangeCurrent"
        :current-page="params.current"
        :page-size="params.pageSize"
        background
        layout="prev, pager, next"
        :total="params.total"
      ></el-pagination>
    </div>
  </div>
</template>
  
  <script>
import {
  getDictionaryItem,
  getCategory,
  getknowByUuid
} from "../../utils/interface";
import axios from "axios"; // 引入axios
export default {
  data() {
    return {
      headerBgUrl: require("../../assets/knowledge.jpg"),
      keyValue: "",
      bookImg: require("../../assets/book.jpg"),
      params: {
        current: 1,
        pageSize: 24,
        total: 0
      },
      typeList: [
        // { title: "水泵标准" },
        // { title: "数字化转型" },
        // { title: "数字化转型" },
        // { title: "分类1" },
        // { title: "分类2" }
      ],
      curIndex: "",
      curUuid: "",
      bookList: [
        // { title: "TAIITRE 100002-2020 数字化转型 价值效益参考模型" },
        // { title: "TAIITRE 100002-2020 数字化转型 价值效益参考模型" },
        // { title: "TAIITRE 100002-2020 数字化转型 价值效益参考模型" },
        // { title: "TAIITRE 100002-2020 数字化转型 价值效益参考模型" }
      ]
    };
  },
  mounted() {
    this.getdataList();
    // this.handlePreview({pictureUrl: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-12-07%2F24efd210b42d4884a4ea95d5354d2403.pdf'})
  },
  methods: {
    query() {
      this.params.current = 1;
      this.getNewsList();
    },
    /* 获取分类 */
    getdataList() {
      getCategory({
        current: 1,
        pageSize: 20
      }).then(res => {
        this.typeList = res[1].children;
        this.typeList.unshift({
          title: "全部",
          uuid: ""
        });
        this.curUuid = res[1].children[0].uuid;
        this.getNewsList(res[1].children[0].uuid);
      });
    },
    /* 获取某一分类具体列表 */
    getNewsList(uuid, title) {
      let params = uuid
        ? {
            current: this.params.current,
            pageSize: this.params.pageSize,
            programUuid: uuid || this.curUuid,
            title: title || this.keyValue
          }
        : {
            current: this.params.current,
            pageSize: this.params.pageSize,
            title: title || this.keyValue,
            showLink: true
          };
      getknowByUuid(params).then(res => {
        this.bookList = res.data;
        this.params.total = res.total;
      });
    },
    /* 预览 */
    handlePreview(row) {
      let fileExtension = row.file.split(".").pop();
      if (fileExtension == "pdf") {
        // https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-12-07%2F24efd210b42d4884a4ea95d5354d2403.pdf
        axios.get(row.file, { responseType: "blob" }).then(data => {
          let responseData = data.data;
          let blob = new Blob([responseData], {
            type: "application/pdf;charset=utf-8"
          });
          const href = URL.createObjectURL(blob);
          window.open(href, "newWindow");
        });
      } else {
        this.$message({
          message: "只能预览pdf文件",
          type: "warning"
        });
      }
    },
    onChangeCurrent(e) {
      this.params.current = e;
      this.getNewsList();
    },
    clickType(index, uuid) {
      this.curIndex = index;
      this.curUuid = uuid;
      this.getNewsList(uuid);
    }
  }
};
</script>
  
  <style scoped lang="less">
@basic-colors: #009999;
/* 搜索框样式 */
/deep/ .el-input-group--append .el-input__inner {
  height: 30px;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  border: none;
}

/* 搜索图标样式 */
/deep/ .el-input-group__append {
  padding: 0 12px;
  background-color: #fff;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  border: none;

  &:hover {
    cursor: pointer;
  }
}
/deep/ .el-input__suffix {
  right: 0px;
  top: -10%;
}
.standardList {
  background-color: #ffffff;
  .noData {
    color: #888;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;
    .nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      /* 搜索框 */
      .serviceSearch {
        height: 50px;
        // background: url('../../assets/publicService/digitalize/26.png') no-repeat center center/100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .greatField-con-search {
          width: 200px;
          // box-shadow: 0 0 10px #9999998a;
          border: 1px solid #999;
          border-radius: 24px;

          .greatField-con-search-icon {
            width: 15px;
            height: 15px;
            background: url("../../assets/search.png") no-repeat center
              center/15px 16px;
          }
        }
      }
    }
    .type-box {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      .type-name {
        width: 80px;
      }
      .type-list {
        flex: 1;
        display: flex;
        flex-flow: row wrap;
        .type-item {
          padding: 2px 4px;
          margin: 0 10px 10px 6px;
          cursor: pointer;
        }
        .item-cur {
          color: #fff;
          background-color: #2646a4;
          border-radius: 4px;
        }
      }
    }
  }
  .tablelist {
    width: 100%;
    background: #f5f5f5;
    .book-con {
      width: 1200px;
      margin: 0 auto;
      min-height: 300px;
      display: flex;
      flex-flow: row wrap;
      padding-top: 20px;
      position: relative;
      .book-item {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        width: 370px;
        height: 110px;
        margin: 15px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 8px;
        padding: 0 15px;
        cursor: pointer;
        .book-img {
          width: 80px;
          height: 110px;
          margin-right: 15px;
          position: relative;
          background-size: 100% 100%;
          top: -12px;
        }
        .book-name {
          flex: 1;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/knowledgeBase/standardList.vue